import { Injectable, Renderer2, RendererFactory2, DOCUMENT, inject } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class ThemeSwitchService {
    private document = inject<Document>(DOCUMENT);

    private renderer: Renderer2;
    private readonly body: HTMLElement;
    private readonly themeClasses = {
        eyefinity: 'eyefinity-theme'
    };

    constructor() {
        const rendererFactory = inject(RendererFactory2);

        this.renderer = rendererFactory.createRenderer(null, null);
        this.body = this.document.body;
    }

    setTheme(themeClass: string): void {
        this.clearThemes();
        if (themeClass) {
            this.renderer.addClass(this.body, themeClass);
        }
    }

    private clearThemes(): void {
        Object.values(this.themeClasses).forEach(theme => {
            if (this.body.classList.contains(theme)) {
                this.renderer.removeClass(this.body, theme);
            }
        });
    }

    setEyefinityTheme(isEyefinity: boolean): void {
        const themeClass = isEyefinity ? this.themeClasses.eyefinity : '';
        this.setTheme(themeClass);
    }
}
